currentResultOverride